import styled from "styled-components";

export const StyledServiceOrderWorkDeliveryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
`;
export const StyledServiceOrderWorkDeliveryDeliveredWorkLinkList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  border: 1px solid #f0f0f0;
  padding: 8px;
  background-color: #fafafa;
  border-radius: 4px;
`;
export const StyledServiceOrderWorkDeliveryDeliveredWorkCustomerComment = styled.div`
  background-color: #ffffff;
  padding: 8px;
  font-size: 1.2rem;
`;

export const StyledServiceOrderWorkDeliveryDeliveredWorkLinkListItem = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  .delivered-work-link-list-item-link-value {
    text-decoration: underline;
    font-weight: 400;
    font-size: 1.4rem;
    color: #1c1726;
    margin: 0;
  }
`;
